import { render, staticRenderFns } from "./GridImg.vue?vue&type=template&id=f5bd8dcc&scoped=true&"
import script from "./GridImg.vue?vue&type=script&lang=js&"
export * from "./GridImg.vue?vue&type=script&lang=js&"
import style0 from "./GridImg.vue?vue&type=style&index=0&id=f5bd8dcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5bd8dcc",
  null
  
)

export default component.exports